import React from 'react';
import { X, Camera, Zap, Loader2 } from 'lucide-react';

const CameraSection = ({ 
  isCameraOpen, 
  isVideoReady, 
  videoRef, 
  canvasRef, 
  cameraStream,
  onCancel,
  onCapture,
  onRestart
}) => {
  if (!isCameraOpen) return null;

  return (
    <div className="mb-4 p-4 bg-gray-900 rounded-xl" style={{ isolation: 'isolate' }}>
      <div className="relative">
        {/* 비디오 영역 */}
        <div className="relative bg-black rounded-lg overflow-hidden" style={{ aspectRatio: '4/3' }}>
          <video 
            ref={videoRef} 
            autoPlay 
            playsInline 
            muted
            className="w-full h-full object-cover" 
          ></video>
          
          {/* 얼굴 가이드라인 오버레이 */}
          <div className="absolute inset-0 flex items-start justify-center pt-12 pointer-events-none">
            {/* 외부 타원 (얼굴 영역 가이드) - 크기 축소, 위치 상단으로 이동 */}
            <div className="relative">
              <div className="w-32 h-40 border-2 border-white border-opacity-60 rounded-full"></div>
              {/* 내부 가이드라인 - 크기에 맞춰 조정 */}
              <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 w-20 h-0.5 bg-white bg-opacity-40"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 w-24 h-0.5 bg-white bg-opacity-40"></div>
              <div className="absolute bottom-1/3 left-1/2 transform -translate-x-1/2 w-18 h-0.5 bg-white bg-opacity-40"></div>
            </div>
            
            {/* 가이드 텍스트 */}
            <div className="absolute top-4 left-4 bg-black bg-opacity-50 text-white px-3 py-1 rounded-full text-sm">
              얼굴을 가이드라인에 맞춰주세요
            </div>
          </div>
          
          {/* 카메라 준비 상태 표시 */}
          {!isVideoReady && (
            <div className="absolute inset-0 bg-black bg-opacity-75 flex items-center justify-center">
              <div className="text-white text-center">
                <Loader2 className="w-8 h-8 animate-spin mx-auto mb-2" />
                <p>카메라 준비 중...</p>
              </div>
            </div>
          )}
        </div>
        
        {/* 촬영 컨트롤 */}
        <div className="flex justify-center items-center gap-4 mt-4">
          {/* 취소 버튼 */}
          <button 
            onClick={onCancel}
            className="btn btn-secondary btn-md"
            style={{ borderRadius: '9999px' }}
          >
            <X className="w-4 h-4" />
            취소
          </button>
          
          {/* 촬영 버튼 - 원형 */}
          <button 
            onClick={onCapture}
            disabled={!isVideoReady || !cameraStream}
            className="relative w-16 h-16 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
            style={{
              backgroundColor: (!isVideoReady || !cameraStream) ? '#d1d5db' : 'white',
              cursor: (!isVideoReady || !cameraStream) ? 'not-allowed' : 'pointer'
            }}
          >
            {/* 외부 링 */}
            <div className="absolute inset-0 rounded-full border-4 border-blue-500 group-hover:border-blue-600 transition-colors"></div>
            {/* 내부 원 */}
            <div className="w-12 h-12 bg-blue-500 group-hover:bg-blue-600 rounded-full transition-colors flex items-center justify-center">
              <Camera className="w-6 h-6 text-white" />
            </div>
          </button>
          
          {/* 재시작 버튼 */}
          <button 
            onClick={onRestart}
            className="btn btn-secondary btn-md"
            style={{ borderRadius: '9999px' }}
            title="카메라 재시작"
          >
            <Zap className="w-4 h-4" />
            재시작
          </button>
        </div>
      </div>
      <canvas ref={canvasRef} className="hidden"></canvas>
    </div>
  );
};

export default CameraSection;
